import { Link } from "react-router-dom";
import { XCircle, Droplets } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-obsidian px-6" data-testid="payment-cancel-page">
      <div className="w-full max-w-md border border-white/10 bg-carbon p-10 text-center">
        <span className="mx-auto flex h-9 w-9 items-center justify-center border border-aqua/50 text-aqua">
          <Droplets size={18} />
        </span>
        <XCircle size={32} className="mx-auto mt-8 text-zinc-500" />
        <h1 className="mt-6 font-display text-2xl font-bold uppercase tracking-tight text-white">
          Payment cancelled
        </h1>
        <p className="mt-3 text-sm text-zinc-400">
          No charge was made. Your booking details are still there whenever you're ready.
        </p>
        <Link
          to="/book"
          data-testid="payment-cancel-retry-link"
          className="mt-8 inline-block border border-aqua bg-aqua px-8 py-3.5 font-mono text-xs font-bold uppercase tracking-[0.2em] text-obsidian transition-colors duration-300 hover:bg-transparent hover:text-aqua"
        >
          Back to booking
        </Link>
      </div>
    </main>
  );
}
